let routes = {
    '3014':"/announcements",
    '3054':"/admin/monthly-report",
    '3226':"/admin/employee-details-report",
    '3029':"/organization-chart",
    '3031':"/awards",
    '3082':"/candidate-in-process",
    '3081':"/postjob",
    '3085':"/schedule-interview-list",
    '3091':"/feedback-master",
    '3093':"/candidate-history",
    '3097':"/hrinterviews",
    // '3103':'/refer-candidate',
    '3180':'/birthday-card',
    '3106':'/hr-policies',
    // '3102':'/refer',
    '3099':'/hr-report',
    // '3120':'/refer-candidate',
    '3094':'/WeeklyJoiner-report',
    '3098':'/interviewer-report',
    '3096':'/WeeklyJoiner-report',
    // '3103':'/candidate-interview-list',
    '3100':'/offer-report',
    '3086':'/interview-staus-report',
    '3208':'/partner-master',
    '3205':'/contractors',
    '3213':'/employee-cost',
    '3211':'/non-billable-employee',
    '3196':'/due-extension-report',
    // '3214':'/kpi-report',
    '3158':'/resource-report',
    '3159':'/skillset-matrix-report',
    '3201':'/on-bench-project-report',
    '3233': '/employee-master-report',
    '3234': '/fulfillment-report',
    '3193':'/master-report',
    '3172':'/bench-tracker-report',
    '3221':'/customer-contact-report',
    '3210':'/kpi-report',
    '3204':'/customer-requirement',
    '3219':'/revenue-by-resource',
    // '3204':'/customer-requirement',
    '3224':'/current-opportunities',
    '3207':'/rom/interview-status-reports',
    '3127':'/client-master',
    '3168':'/domain-master',
    '3185':'/incentive-master',
    '3153':'/currency-master',
    // '3185':'/incentive-master',
    '3151':'/location-master',
    '3150':'/technology-master',
    '3206':'/job-master',
    '3152':'/course-master',
    '3169':'/skill-master',
    '3081':'/postjob',
    '3085':'/schedule-interview-list',
    '3091':'/feedback-master',
    '3093':'/candidate-history',
    '3097':'/hrinterviews',
    '3082':'/candidate-in-process',
    '3098':'/interviewer-report',
    '3096':'/weeklyjoiner-report',
    '3100':'/offer-report',
    '3217':'/candidate-interview-list',
    '3120':'/my-refercandidate-status',
    '3086':'/interview-status-report',
    '3099':'/hr-report',
    '3094':'/periodic-report',
    '3102':'/refer-candidate/add',
    '3103':'/refer-candidate',
    '3106':'/hr-policies',
    '3180':'/birthday-card',
    '3122':'/pr-status',
    '3121':'/pr-score-report',
    '3110':'/appraisal-cycles',
    '3111':'/question-masters',
    '3112':'/appraisal-template-masters',
    '3118':'/my-performance-evaluation-report',
    '3232':'/team-performance-evaluations',
    '3218':'/pr-subjective-evaluation-report',
    '3115':'/performance-evaluations',
    '3119':'/team-evaluation-report',
    '3117':'/pr-evaluation-report',
    '3017':'/attendance-approval',
    '3006': '/attendance-statement',
    '3008':'/apply-leave',
    '3007':'/approve-leave',   
    '3067':'/team-leave-status-report',
    '429':'/leave-history-report',
    '3021':'/apply-comp-off',
    '3104':'/comp-off-statement',
    '3070':'/comp-off-history-report',
    '3022':'/approve-comp-off',
    '3065':'/holiday-calender',
    '3181':'/model-master',
    '3175':'/vendor-master',
    '3173':'/asset-category',
    '3215':'/disposed-of-asset-report',
    '3051':'/asset-allocation',
    '3058':'/add-asset',
    '3071':'/asset-return',
    '3062':'/asset-allocation-details',
    '3195':'/purchase-summary',
    '3197':'/summary-report-it-report',
    '3182':'/repairable-assets',
    '3182':'/repairable-assets',
    '3074':'/asset-return-statement',
    '3183':'/obsolete-assets',
    '3194':'/master-report-it-assets',
    '3198':'/subscription-summary',
    '3028':'/manage/admin/tickets',
    '3027':'/admin/tickets',
    '3045':'/IT/support/tickets',
    '3047':'/admin/IT/support/tickets',
    '3202':'/employee-earning-report',
    '3066':'/my-components',
    '3080':'/incentive-CCA-statement',
    '3078':'/incentive-CCA/add',
    '3079':'/incentive-CCA/approval',
    '3203':'/employee-component',
    '3105':'/employee-ctc-report',
    '3068':'/team-payroll',
    '3034':'/my-payroll',
    '3220':'/employee-tax-regime',
    '3026':'/team-reimbursements',
    '3223':'/nice-master-report',
    '3032':'/expense-advance',
    '3019':'/new-tne',
    '3107':'/leave-encashment',
    '3108':'/leave-encashment-report',
    '3050':'/my-training-incentives',
    '3023':'/all-reimbursements',
    '3024':'/my-reimbursements/report',
    '3039':'/expense-advance-report',
    '3227':'/contractors-fee',
    '3076':'/expense-settlement-statement',
    '565':'/rujul/hrm/it-declaration',
    '40':'/rujul/hrm/payroll',
    '39':'/rujul/hrm/payroll-scales',
    '566':'/rujul/hrm/employee-it-declaration/list',
    '344':'/rujul/hrm/calculate-payroll',
    '428':'/rujul/hrm/confirmation-payroll',
    '568':'/rujul/hrm/employee-payroll-increment',
    '519':'/rujul/hrm/attendance-book-approval',
    '516':'/rujul/hrm/attendance-book',
    '520':'/rujul/hrm/attendance-book-statement',
    '21':'/area-master',
    '17':'/rujul/admin/general-master',
    '332':'/holiday',
    '30':'/hrCalendar',
    '326':'/shift',
    '329':'/department',
    '330':'/designation',
    '3167':'/award-master',
    '518':'/attendanceStatus',
    '56':'/rujul/admin/object-type',
    '13':'/roles',
    '14':'/rujul/user-list',
    '476':'/employee-list',
    '3040':'/user/pay-slip',
    '3222':'/my-tds-certificate',
    '3063':'/all-projects',
    '3128':'/create-project',
    '349':'/rujul/hrm/print-email-payslip',
    '553':'/rujul/hrm/generate-payroll-advice',
    '3129':'/project-invoice-list',
    '3131':'/project-invoice-report/consulting-content',
    '3209':'/Kpi-summary',
    '3210':'/kpi-report',
    '3002':'/knowledge-base',
    '3044':'/admin/knowledge-base',
    '3072':'/admin/announce-events',
    '563':'/rujul/hrm/income-tax-slab',
    '3012':'/resource-allocation',
    '3069':'/my-resource',
    '3109':'/project-status-report',
    '3011':'/my-project',
    '3013':'/my-task',
    '3043':'/my-team-task',
    '3035':'/allocate-task',
    '3156':'/training-calender',
    '3147':'/my-training',
    '3033':'/approve-training',
    '3186':'/my-team-training-incentive',
    '3030':'/training-incentive',
    '3139':'/invoice-list-training',
    '3142':'/tne-invoivelist-training',
    '3038':'/my-team-training-incentive',
    '3141':'/report/invoice-report-training',
    '3154':'/report/all-report',
    '3161':'/report/all-invoice-report',
    '3133':'/report/tne-invoice-report',
    '3143':'/report/tne-invoice-report-training',
    '3186':'/training-approval-lead',
    '525':'/rujul/hrm/payroll-statement',
    '381':'/leaveStatement',
    '356':'/leaveSummary',
    '333':'/leave-list',
    '580':'/leave-ledger',
    '3236':'/hr-attendance-approval',
    '3237':'/upcoming-joiners',
    '3238':'/offer-letter-listing',
    '3239':'/company-financial-month',
    '3240':'/apply/special-leave',
    '3241':'/approve/special-leave',
    '3242':'/resume-parser',
    '3243':'/employee/history',
    '3244':'/pm/question-masters',
    '3245':'/employee/feedback',
    '3246':'/pr-designation-category',
    '3247':'/category-designation',
    '3248':'/pr-master-report',
    '3249':'/annual-bonus-report',
    '3250':'/annual-appraisal-report',
    '3251':'/annual-finance-report',
    '3252':'/asset-maintenance-listing',
    '3253':'/requisition-tracker-report',
    '3254':'/requirement-tracker-report'
}


export default routes;